import axios from "@/plugins/axios.js";

export default {
  getAllCode: function() {
    return axios.post("/Sys/getAllCodeMap", {});
  },
  getZphd(param) {
    return axios.post("/Zphd/queryZphd", param);
  }
};
